// @flow
import * as React from 'react';
import classNames from 'classnames';

import './PopupTriangle.css';

type Props = {
  top?: boolean,
  right?: boolean,
  bottom?: boolean,
  left?: boolean
};

export default class PopupTriangle extends React.Component<Props, {}> {
  render() {
    const { top, right, bottom, left } = this.props;
    const svgProps = top || bottom ? { width: 22, height: 4 } : { width: 4, height: 22 };
    const points = top ? '0,4 11,0 22,4' : right ? '0,0 4,11 0,22' : bottom ? '0,0 22,0 11,4' : '4,0 4,22 0,11';

    return (
      <svg name="PopupTriangle" {...svgProps} className={classNames({ top, right, bottom, left })}>
        <polygon points={points} fill="var(--dropdown-bg-selected)" />
      </svg>
    );
  }
}
